module.exports = __webpack_public_path__ + "static/imgdestaques-9c30fd6c83346397a3738d5a41cdcbfb.png";